module.exports = __webpack_public_path__ + "static/gift-emoji-7161099f8820efafb4b7f8f04baa04d4.png";